module.exports = __webpack_public_path__ + "img/ILS.81ecfb69.svg";